export const internCVList = [
  {
    name_: "Vedic Dutta",
    title: "Sprinklr | CH",
    dept: "CH",
    category: "software",
    company: "Sprinklr",
    cover: "/assets/images/Vedic_Dutta_cv.png",
    profilecolor: "#FFC0CB",
    id: 166,
  },
  {
    name_: "Telu Amruthavarshini",
    title: "Piramal Finance | CS",
    dept: "CS",
    category: "finance",
    company: "Piramal Finance",
    cover: "/assets/images/Telu_Amruthavarshini_cv.png",
    profilecolor: "#FFC0CB",
    id: 165,
  },
  {
    name_: "Tarang C Rangani",
    title: "Samsung | EE",
    dept: "EE",
    category: "software",
    company: "Samsung",
    cover: "/assets/images/Tarang_Rangani_cv.png",
    profilecolor: "#FFC0CB",
    id: 164,
  },
  {
    name_: "Tadiparthi Adarsh",
    title: "Zepto | EE",
    dept: "EE",
    category: "software",
    company: "Zepto",
    cover: "/assets/images/Adarsh_Tadiparthi_cv.png",
    profilecolor: "#FFC0CB",
    id: 163,
  },
  {
    name_: "Sonune Pratik Ganesh",
    title: "Texas Instruments | CS",
    dept: "CS",
    category: "core",
    company: "Texas Instruments",
    cover: "/assets/images/Pratik_Sonune_cv.png",
    profilecolor: "#FFC0CB",
    id: 162,
  },
  {
    name_: "Shreya Mishra",
    title: "Accenture | CH",
    dept: "CH",
    category: "software",
    company: "Accenture",
    cover: "/assets/images/Shreya_Mishra_cv.png",
    profilecolor: "#FFC0CB",
    id: 161,
  },
  {
    name_: "Shivam Kumar",
    title: "Trumio | IM",
    dept: "IM",
    category: "software",
    company: "Trumio",
    cover: "/assets/images/Shivam_Kumar_cv.png",
    profilecolor: "#FFC0CB",
    id: 160,
  },
  {
    name_: "Shashank S",
    title: "Qualcomm | ECE",
    dept: "ECE",
    category: "core",
    company: "Qualcomm",
    cover: "/assets/images/Shashank_S_cv.png",
    profilecolor: "#FFC0CB",
    id: 159,
  },
  {
    name_: "Sayan Ghosh",
    title: "AWL | CH",
    dept: "CH",
    category: "software",
    company: "AWL",
    cover: "/assets/images/Sayan_Ghosh_cv.png",
    profilecolor: "#FFC0CB",
    id: 158,
  },
  {
    name_: "Saroja Bamra",
    title: "Corridor Platform | HS",
    dept: "HS",
    category: "software",
    company: "Corridor Platform",
    cover: "/assets/images/Saroja_Bamra_cv.png",
    profilecolor: "#FFC0CB",
    id: 157,
  },
  {
    name_: "Sanskar Sadanand Yerule",
    title: "BNY Mellon | ME",
    dept: "ME",
    category: "software",
    company: "BNY Mellon",
    cover: "/assets/images/Sanskar_cv.png",
    profilecolor: "#FFC0CB",
    id: 156,
  },
  {
    name_: "Sachin",
    title: "JLR | CH",
    dept: "CH",
    category: "software",
    company: "JLR ",
    cover: "/assets/images/Sachin_Kadyan_cv.png",
    profilecolor: "#FFC0CB",
    id: 155,
  },
  {
    name_: "Ruturaj Acharya",
    title: "Battery Smart | AE",
    dept: "AE",
    category: "product",
    company: "Battery Smart",
    cover: "/assets/images/Ruturaj_Acharya_cv.png",
    profilecolor: "#FFC0CB",
    id: 154,
  },
  {
    name_: "Roctotpal Sandilya",
    title: "ITC | IE",
    dept: "IE",
    category: "core",
    company: "ITC",
    cover: "/assets/images/Roctotpal_Sandilya_cv.png",
    profilecolor: "#FFC0CB",
    id: 153,
  },
  {
    name_: "Ram Mohan Patel",
    title: "PATTERN | AG",
    dept: "AG",
    category: "software",
    company: "PATTERN",
    cover: "/assets/images/Ram_Mohan_Patel_cv.png",
    profilecolor: "#FFC0CB",
    id: 152,
  },
  {
    name_: "Rajit Jiten Bhojani",
    title: "Goldman Sachs | MA",
    dept: "MA",
    category: "quant",
    company: "Goldman Sachs",
    cover: "/assets/images/Rajit_Bhojani_cv.png",
    profilecolor: "#FFC0CB",
    id: 151,
  },
  {
    name_: "Rahul Ranjan",
    title: "DTDC | MF",
    dept: "MF",
    category: "product",
    company: "DTDC",
    cover: "/assets/images/Rahul_Ranjan_cv.png",
    profilecolor: "#FFC0CB",
    id: 150,
  },
  {
    name_: "Priyanshu Gourav",
    title: "SAMSUNG | CS",
    dept: "CS",
    category: "software",
    company: "SAMSUNG",
    cover: "/assets/images/Anshu_Kumar_cv.png",
    profilecolor: "#FFC0CB",
    id: 149,
  },
  {
    name_: "Prasit Mazumder",
    title: "QUALCOMM | ECE",
    dept: "ECE",
    category: "software",
    company: "QUALCOMM",
    cover: "/assets/images/Prasit_Mazumder_cv.png",
    profilecolor: "#FFC0CB",
    id: 148,
  },
  {
    name_: "Patil Ruturaj Pravin",
    title: "INITO | MF",
    dept: "MF",
    category: "core",
    company: "INITO ",
    cover: "/assets/images/Ruturaj_Patil_cv.png",
    profilecolor: "#FFC0CB",
    id: 147,
  },
  {
    name_: "Jakkinapalli Satya Ravi Sujit",
    title: "BCG | IM",
    dept: "IM",
    category: "consultancy",
    company: "BCG",
    cover: "/assets/images/Sujit_cv.png",
    profilecolor: "#FFC0CB",
    id: 146,
  },
  {
    name_: "Harsh Raj Gupta",
    title: "JOHNSON & JOHNSON | CH",
    dept: "CH",
    category: "core",
    company: "JOHNSON & JOHNSON",
    cover: "/assets/images/Harsh_Gupta_cv.png",
    profilecolor: "#FFC0CB",
    id: 145,
  },
  {
    name_: "Gaurav Roy",
    title: "SALESFORCE | CS",
    dept: "CS",
    category: "software",
    company: "SALESFORCE",
    cover: "/assets/images/Gaurav_Roy_cv.png",
    profilecolor: "#FFC0CB",
    id: 144,
  },
  {
    name_: "Didwm Mochahary",
    title: "TATA Steel | ME",
    dept: "ME",
    category: "core",
    company: "TATA Steel",
    cover: "/assets/images/Didwm_Mochahary_cv.png",
    profilecolor: "#FFC0CB",
    id: 143,
  },
  {
    name_: "Dhruv Jain",
    title: "HUL | CH",
    dept: "CH",
    category: "core",
    company: "HUL ",
    cover: "/assets/images/Dhruv_Jain_cv.png",
    profilecolor: "#FFC0CB",
    id: 142,
  },
  {
    name_: "Dhareddy Vishwaksen Reddy",
    title: "QUALCOMM | ECE",
    dept: "ECE",
    category: "core",
    company: "QUALCOMM",
    cover: "/assets/images/Dhareddy_Vishwaksen_Reddy_cv.png",
    profilecolor: "#FFC0CB",
    id: 141,
  },
  {
    name_: "Bongirwar Harsh Nitin",
    title: "LEK | AG",
    dept: "AG",
    category: "consultancy",
    company: "LEK",
    cover: "/assets/images/Harsh_Bongirwar_cv.png",
    profilecolor: "#FFC0CB",
    id: 140,
  },
  {
    name_: "Bhandaru Uma Nethrika",
    title: "SIEMENS EDA | AE",
    dept: "AE",
    category: "software",
    company: "SIEMENS EDA",
    cover: "/assets/images/Uma_Nethrika_cv.png",
    profilecolor: "#FFC0CB",
    id: 139,
  },
  {
    name_: "Banothu Karthik",
    title: "DEVREV | CS",
    dept: "CS",
    category: "software",
    company: "DEVREV",
    cover: "/assets/images/Karthik_Banothu_cv.png",
    profilecolor: "#FFC0CB",
    id: 138,
  },
  {
    name_: "Ashvath Krishnan",
    title: "NVIDIA | IE",
    dept: "IE",
    category: "core",
    company: "NVIDIA",
    cover: "/assets/images/Ashvath_Krishnan_cv.png",
    profilecolor: "#FFC0CB",
    id: 137,
  },
  {
    name_: "Aruj Mishra",
    title: "NVIDIA | ECE",
    dept: "ECE",
    category: "core",
    company: "NVIDIA",
    cover: "/assets/images/Aruj_Mishra_cv.png",
    profilecolor: "#FFC0CB",
    id: 136,
  },
  {
    name_: "Arudeep Kumar",
    title: "Graviton | CS",
    dept: "CS",
    category: "quant",
    company: "Graviton",
    cover: "/assets/images/Arudeep_Kumar_cv.png",
    profilecolor: "#FFC0CB",
    id: 135,
  },
  {
    name_: "Arnab Sarkar",
    title: "Nation with NaMo | AE",
    dept: "AE",
    category: "data",
    company: "Nation with NaMo",
    cover: "/assets/images/Arnab_Sarkar_cv.png",
    profilecolor: "#FFC0CB",
    id: 134,
  },
  {
    name_: "Anjali S Vallakudath",
    title: "SLB | MI",
    dept: "MI",
    category: "core",
    company: "SLB",
    cover: "/assets/images/Anjali_sv_cv.png",
    profilecolor: "#FFC0CB",
    id: 133,
  },
  {
    name_: "Anirvan Krishna",
    title: "OLA | EE",
    dept: "EE",
    category: "software",
    company: "OLA ",
    cover: "/assets/images/Anirvan_Krishna_cv.png",
    profilecolor: "#FFC0CB",
    id: 132,
  },
  {
    name_: "Akash Manna",
    title: "AMAZON | MI",
    dept: "MI",
    category: "software",
    company: "Amazon",
    cover: "/assets/images/Akash_Manna_cv.png",
    profilecolor: "#FFC0CB",
    id: 131,
  },
  {
    name_: "Ajay Paliwal",
    title: "Adobe | EE",
    dept: "EE",
    category: "software",
    company: "Adobe",
    cover: "/assets/images/Ajay_Paliwal_cv.png",
    profilecolor: "#FFC0CB",
    id: 130,
  },
  {
    name_: "Abhishek Sinha",
    title: "SLB | ME",
    dept: "ME",
    category: "core",
    company: "SLB",
    cover: "/assets/images/Abhishek_Sinha_cv.png",
    profilecolor: "#FFC0CB",
    id: 129,
  },
  {
    id: 128,
    name_: "Shashank S",
    title: "Qualcomm | EC",
    dept: "EC",
    category: "core",
    company: "Qualcomm",
    cover: "assets/images/Shashank_S_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 127,
    name_: "Vedant Palit",
    title: "J.P. Morgan Chase | IM",
    dept: "IM",
    category: "finance",
    company: "J.P. Morgan Chase",
    cover: "assets/images/Vedant_Palit_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 126,
    name_: "Varun Agrawal",
    title: "ConvoZen.AI (NoBroker) | CH",
    dept: "CH",
    category: "data",
    company: "ConvoZen.AI (NoBroker)",
    cover: "assets/images/Varun_Agrawal_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 125,
    name_: "Tuhin Mondal",
    title: "Glean | CS",
    dept: "CS",
    category: "software",
    company: "Glean",
    cover: "assets/images/Tuhin_Mondal_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 124,
    name_: "Sunrit Sarkar",
    title: "Amazon | EC",
    dept: "EC",
    category: "software",
    company: "Amazon",
    cover: "assets/images/Sunrit_Sarkar_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 123,
    name_: "Soumyadip Paik",
    title: "American Express | MA",
    dept: "MA",
    category: "data",
    company: "American Express",
    cover: "assets/images/Soumyadip_Paik_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    name_: "Vuriti Keerthana",
    title: "Twilio | CS",
    dept: "CS",
    category: "software",
    company: "Twilio",
    cover: "/assets/images/Vuriti_Keerthana_cv.png",
    profilecolor: "#FFC0CB",
    id: 122,
  },
  {
    id: 121,
    name_: "Wakode Sahil Khushal",
    title: "UiPath | EC",
    dept: "EC",
    category: "software",
    company: "UiPath",
    cover: "assets/images/Wakode_Sahil_Khushal_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 120,
    name_: "Vivek Malik",
    title: "Amazon | EE",
    dept: "EE",
    category: "software",
    company: "Amazon",
    cover: "assets/images/Vivek_Malik_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 119,
    name_: "Sharanya Chakraborty",
    title: "Microsoft | CS",
    dept: "CS",
    category: "software",
    company: "Microsoft",
    cover: "assets/images/Sharanya_Chakraborty_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 118,
    name_: "Shahil Gupta",
    title: "DE Shaw | ME",
    dept: "ME",
    category: "software",
    company: "DE Shaw",
    cover: "assets/images/Shahil_Gupta_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 117,
    name_: "Ruturaj Patil",
    title: "Inito | MF",
    dept: "MF",
    category: "core",
    company: "Inito",
    cover: "assets/images/Ruturaj_Patil_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 116,
    name_: "Roshmitha Rajesh",
    title: "Google Hardware | EE",
    dept: "EE",
    category: "core",
    company: "Google Hardware",
    cover: "assets/images/Roshmitha_Rajesh_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 115,
    name_: "Rajit Bhojani",
    title: "Goldman Sachs | MA",
    dept: "MA",
    category: "quant",
    company: "Goldman Sachs",
    cover: "assets/images/Rajit_Bhojani_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 114,
    name_: "Pratik Sonune",
    title: "Texas Instruments | CS",
    dept: "CS",
    category: "software",
    company: "Texas Instruments",
    cover: "assets/images/Pratik_Sonune_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 113,
    name_: "Pradyumn Mahajan",
    title: "Inito | AE",
    dept: "AE",
    category: "core",
    company: "Inito",
    cover: "assets/images/Pradyumn_Mahajan_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 112,
    name_: "Parth Sinha",
    title: "JPMorgan Chase | MA",
    dept: "MA",
    category: "quant",
    company: "JPMorgan Chase",
    cover: "assets/images/Parth_sinha_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 111,
    name_: "Mohit Hemnani",
    title: "Siemens | EE",
    dept: "EE",
    category: "software",
    company: "Siemens",
    cover: "assets/images/Mohit_Hemnani_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 110,
    name_: "Karthik Banothu",
    title: "DevRev | CS",
    dept: "CS",
    category: "software",
    company: "DevRev",
    cover: "assets/images/Karthik_Banothu_cv.png",
    profilecolor: "#FFC0CB",
  },
  
  {
    id: 110,
    name_: "Mohit Hemnani",
    title: "Siemens EDA | EE",
    dept: "EE",
    category: "software",
    company: "Siemens EDA",
    cover: "assets/images/Mohit_Hemnani_cv.png",
    profilecolor: "#FFC0CB"
  },
  {
    id: 109,
    name_: "Konduri Jeevan Varma",
    title: "Siemens EDA | CS",
    dept: "CS",
    category: "software",
    company: "Siemens EDA",
    cover: "assets/images/Konduri_Jeevan_Varma_cv.png",
    profilecolor: "#FFC0CB"
  },
  {
    id: 108,
    name_: "Kubal Aryan Nilesh",
    title: "Nation With NaMo | MT",
    dept: "MT",
    category: "consultancy",
    company: "Nation With NaMo",
    cover: "assets/images/Aryan_Kubal_cv.png",
    profilecolor: "#FFC0CB"
  },
  {
    id: 107,
    name_: "Md Mutahhir Azam",
    title: "SRI Noida | IE",
    dept: "IE",
    category: "software",
    company: "SRI Noida",
    cover: "assets/images/Md_Mutahhir_Azam_cv.png",
    profilecolor: "#FFC0CB"
  },
  {
    id: 106,
    name_: "Kalikiri Hrushikesh Reddy",
    title: "APT Portfolio | CS",
    dept: "CS",
    category: "core",
    company: "APT Portfolio",
    cover: "assets/images/Hrushikesh_Reddy_cv.png",
    profilecolor: "#FFC0CB"
  },
  {
    id: 105,
    name_: "Jyotiraditya Harichandan",
    title: "Siemens EDA | EE",
    dept: "EE",
    category: "software",
    company: "Siemens EDA",
    cover: "assets/images/Jyotiraditya_Harichandan_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 104,
    name_: "Jitendra Bhati",
    title: "ThoughtSpot | BT",
    dept: "BT",
    category: "software",
    company: "ThoughtSpot",
    cover: "assets/images/Jitendra_Bhati_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 103,
    name_: "Irsh Vijay",
    title: "OLA Krutrim | ECE",
    dept: "ECE",
    category: "data",
    company: "OLA Krutrim",
    cover: "assets/images/Irsh_Vijay_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 102,
    name_: "Harsh Gupta",
    title: "Johnson & Johnson | CH",
    dept: "CH",
    category: "core",
    company: "Johnson & Johnson",
    cover: "assets/images/Harsh_Gupta_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 101,
    name_: "Dhruv Parikh",
    title: "Zepto | CH",
    dept: "CH",
    category: "consultancy",
    company: "Zepto",
    cover: "assets/images/Dhruv_Parikh_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 100,
    name_: "Deep Ghosh",
    title: "NVIDIA | ECE",
    dept: "ECE",
    category: "core",
    company: "NVIDIA",
    cover: "assets/images/Deep_Ghosh_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 99,
    name_: "Dhanavath Pranay Naik",
    title: "Khurana and Khurana | IP",
    dept: "IP",
    category: "consultancy",
    company: "Khurana and Khurana",
    cover: "assets/images/DHANAVATH_PRANAY_NAIK_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 98,
    name_: "Biswajeet Nayak",
    title: "Nomura | CH",
    dept: "CH",
    category: "finance",
    company: "Nomura",
    cover: "assets/images/Biswajeet_Nayak_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 97,
    name_: "Bhanu Pratap",
    title: "JP Morgan Chase & Co. | MA",
    dept: "MA",
    category: "quant",
    company: "JP Morgan Chase & Co.",
    cover: "assets/images/Bhanu_Pratap_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 96,
    name_: "Avik Halder",
    title: "Adobe | ECE",
    dept: "ECE",
    category: "software",
    company: "Adobe",
    cover: "assets/images/Avik_Halder_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 95,
    name_: "Ankit Dutta",
    title: "Battery Smart | GG",
    dept: "GG",
    category: "data",
    company: "Battery Smart",
    cover: "assets/images/Ankit_Dutta_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 94,
    name_: "Amrita Ghosh",
    title: "Johnson & Johnson | ME",
    dept: "ME",
    category: "core",
    company: "Johnson & Johnson",
    cover: "assets/images/Amrita_Ghosh_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 93,
    name_: "Akshat Pandey",
    title: "Samsung R&D Institute Bangalore | CSE",
    dept: "CSE",
    category: "software",
    company: "Samsung R&D Institute Bangalore",
    cover: "assets/images/Akshat_Pandey_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 92,
    name_: "Akshat Lathi",
    title: "Axxela | CY",
    dept: "CY",
    category: "finance",
    company: "Axxela",
    cover: "assets/images/Akshat_Lathi_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 91,
    name_: "Aditya Singh Dabas",
    title: "Procter and Gamble | MF",
    dept: "MF",
    category: "product",
    company: "Procter and Gamble",
    cover: "assets/images/Aditya_Singh_Dabas_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 90,
    name_: "Aditya Panda",
    title: "Graviton Research Capital LLP | ECE",
    dept: "ECE",
    category: "quant",
    company: "Graviton Research Capital LLP",
    cover: "assets/images/Aditya_Panda_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 89,
    name_: "Aditya Prakash",
    title: "Bajaj Auto | ME",
    dept: "ME",
    category: "core",
    company: "Bajaj Auto",
    cover: "assets/images/Aditya_Prakash_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 88,
    name_: "Aditya Nandy",
    title: "American Express | EE",
    dept: "EE",
    category: "data",
    company: "American Express",
    cover: "assets/images/Aditya_Nandy_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 87,
    name_: "Adarsh Tadiparthi",
    title: "Zepto | EE",
    dept: "EE",
    category: "software",
    company: "Zepto",
    cover: "assets/images/Adarsh_Tadiparthi_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 86,
    name_: "Abhisekh Mukherjee",
    title: "Eightfold.Ai | Mathematics and Computing",
    dept: "MA",
    category: "software",
    company: "Eightfold.Ai",
    cover: "assets/images/Abhisekh_Mukherjee_cv.png",
    profilecolor: "#FFC0CB",
  },
  {
    id: 85,
    name_:'Sourabh Soumyakanta Das',
    title: 'Uber | CS',
    dept:'CS',
    category: 'software',
    company: "Uber",
    cover: 'assets/images/Sourabh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 84,
    name_:'Shubh Guwalani',
    title: 'Fidelity Investments | BT',
    dept:'BT',
    category: 'data',
    company: "Fidelity Investments",
    cover: 'assets/images/Shubh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 83,
    name_:'Riyan Biswas',
    title: 'JM Financial Ltd. | MT',
    dept:'MT',
    category: 'product',
    company: "JM Financial Ltd. ",
    cover: 'assets/images/Riyan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 82,
    name_:'Kunal Kumar',
    title: 'Standard Chartered | MA',
    dept:'MA',
    category: 'software',
    company: "Standard Chartered",
    cover: 'assets/images/Kunal_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 81,
    name_:'Gaddam Sree Harshitha',
    title: 'Google | CS',
    dept:'CS',
    category: 'software',
    company: "Google",
    cover: 'assets/images/harshitha_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 80,
    name_:'Zaid Irfan Ali',
    title: 'Limechat | EE',
    dept:'EE',
    category: 'software',
    company: "Limechat",
    cover: 'assets/images/Zaid_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 79,
    name_:'Shelly Aggarwal',
    title: 'Google | IE',
    dept:'IE',
    category: 'software',
    company: "Google",
    cover: 'assets/images/Shelly_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 78,
    name_:'Aryan Kumar',
    title: 'Oracle | IM',
    dept:'IM',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/aryankumar_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 77,
    name_:'Dillip Dibyajyoti Dash',
    title: 'Qualcomm | EC',
    dept:'EC',
    category: 'core',
    company: "Qualcomm",
    cover: 'assets/images/Dillip_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 76,
    name_:'Priyank Mundra',
    title: 'BNY Mellon | EC',
    dept:'EC',
    category: 'software',
    company: "Menon & Menon Pvt. Ltd.",
    cover: 'assets/images/Priyank_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 75,
    name_:'Jainish Solanki',
    title: 'Menon & Menon Pvt. Ltd. | AE',
    dept:'AE',
    category: 'core',
    company: "Menon & Menon Pvt. Ltd.",
    cover: 'assets/images/Jainish_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 74,
    name_:'Prachi Priya',
    title: 'TATA AIG | GG',
    dept:'GG',
    category: 'data',
    company: "TATA AIG",
    cover: 'assets/images/Prachi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 73,
    name_:'Khushi Agrawal',
    title: 'Mastercard | IE',
    dept:'IE',
    category: 'software',
    company: "Mastercard",
    cover: 'assets/images/Khushi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 72,
    name_:'Rajarshi Mandal',
    title: 'Oracle | EC',
    dept:'EC',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Rajarshi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 71,
    name_:'Sanidhya Raj',
    title: 'Texas Instruments | MA',
    dept:'MA',
    category: 'software',
    company: "Texas Instruments",
    cover: 'assets/images/Sanidhya_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 70,
    name_:'Samarth Singh',
    title: 'McKinsey & Co | ME',
    dept:'ME',
    category: 'consultancy',
    company: "McKinsey & Co",
    cover: 'assets/images/Samarth_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 69,
    name_:'Tanish Goel',
    title: 'TATA AIG | ME',
    dept:'ME',
    category: 'product',
    company: "TATA AIG",
    cover: 'assets/images/Tanish_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 68,
    name_:'Vedant Tarole',
    title: 'Sprinklr | IM',
    dept:'IM',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/Vedant_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 67,
    name_:'Saheb Lohakare',
    title: 'HUL | CH',
    dept:'CH',
    category: 'core',
    company: "HUL",
    cover: 'assets/images/Saheb_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 66,
    name_:'Pranshul Gupta',
    title: 'Nomura | MA',
    dept:'MA',
    category: 'quant',
    company: "Nomura",
    cover: 'assets/images/Pranshul_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 65,
    name_:'Pravalika Das',
    title: 'EXL Services | CH',
    dept:'CH',
    category: 'data',
    company: "EXL Services",
    cover: 'assets/images/Pravalika_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 64,
    name_:'Debanu Das',
    title: 'Texas Instruments | EC',
    dept:'EC',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/Debanu_cv1.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 63,
    name_:'Rajarshi Mandal',
    title: 'Oracle | EC',
    dept:'EC',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Rajarshi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 62,
    name_:'Diptendu Sarkar',
    title: 'RAAM Group | ME',
    dept:'ME',
    category: 'product',
    company: "RAAM Group",
    cover: 'assets/images/Diptendu_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 61,
    name_:'Muskan Gupta',
    title: 'Microsoft | CY',
    dept:'CY',
    category: 'software',
    company: "Microsoft",
    cover: 'assets/images/Muskan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 60,
    name_:'Shatansh Patnaik',
    title: 'Oracle | MA',
    dept:'MA',
    category: 'software',
    company: "Oracle",
    cover: 'assets/images/Shatansh_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 59,
    name_:'Krishna Kolte',
    title: 'VISA | EE',
    dept:'EE',
    category: 'software',
    company: "VISA",
    cover: 'assets/images/Krishna_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 58,
    name_:'Neeraj Boddeda',
    title: 'Microsoft | CS',
    dept:'CS',
    category: 'data',
    company: "Microsoft",
    cover: 'assets/images/Neeraj_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 57,
    name_:'Sneharghya Debnath',
    title: 'Nvidia | EC',
    dept:'EC',
    category: 'core',
    company: "Nvidia",
    cover: 'assets/images/sneharghya_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 56,
    name_:'Archana Satapathy',
    title: 'Accenture | MI',
    dept:'MI',
    category: 'consultancy',
    company: "Accenture",
    cover: 'assets/images/archana_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 55,
    name_:'Himdyuti Sandilya',
    title: 'Salesforce | EE',
    dept:'EE',
    category: 'software',
    company: "Salesforce",
    cover: 'assets/images/himdyuti_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 54,
    name_:'Malla Dhanraj',
    title: 'JM Financial Ltd. | IM',
    dept:'IM',
    category: 'data',
    company: "JM Financial Ltd.",
    cover: 'assets/images/malla_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 53,
    name_:'Manas Chandarana',
    title: 'Morgan Stanley | EE',
    dept:'EE',
    category: 'product',
    company: "Morgan Stanley",
    cover: 'assets/images/manas_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 52,
    name_:'Mohd Amaan',
    title: 'Amazon | EE',
    dept:'EE',
    category: 'software',
    company: "Amazon",
    cover: 'assets/images/amaan_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 51,
    name_:'Khush Bajaj',
    title: 'WinZo Games | CS',
    dept:'CS',
    category: 'software',
    company: "WinZo Games",
    cover: 'assets/images/khush_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 50,
    name_:'Avi Saraf',
    title: 'Texas Instruments | EE',
    dept:'EE',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/avi_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 49,
    name_:'Ayushi',
    title: 'Microsoft | IE',
    dept:'IE',
    category: 'software',
    company: "Microsoft",
    cover: 'assets/images/ayushi_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 48,
    name_:'Tejas Saxena',
    title: 'Nomura | CH',
    dept:'CH',
    category: 'finance',
    company: "Nomura",
    cover: 'assets/images/tejas_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 47,
    name_:'N Anushka',
    title: 'Adobe | EC',
    dept:'EC',
    category: 'data',
    company: "Adobe",
    cover: 'assets/images/anushka_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 46,
    name_:'Pranav Kulkarni',
    title: 'AlphaGrep | CS',
    dept:'CS',
    category: 'software',
    company: "AlphaGrep",
    cover: 'assets/images/pranav_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 45,
    name_:'Abhyank Singh',
    title: 'LEK | EX',
    dept:'EX',
    category: 'consultancy',
    company: "LEK",
    cover: 'assets/images/abhyank_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 44,
    name_:'Kshitij Banerjee',
    title: 'Texas Instruments | EE',
    dept:'EE',
    category: 'core',
    company: "Texas Instruments",
    cover: 'assets/images/kshitij_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 43,
    name_:'Amit Kumar',
    title: 'Nutanix | CS',
    dept:'CS',
    category: 'software',
    company: "Nutanix",
    cover: 'assets/images/amit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 42,
    name_:'Sanskar Gupta',
    title: 'Goldman Sachs | HS',
    dept:'HS',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/sanskar_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 41,
    name_:'Bhuvan Rangoju',
    title: 'Databricks | MA',
    dept:'MA',
    category: 'software',
    company: "Databricks",
    cover: 'assets/images/bhuvan_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 40,
    name_:'Arjit Lohia',
    title: 'Sprinklr | EC',
    dept:'EC',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/arjit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 39,
    name_:'Rohit R Gaikwad',
    title: 'Bajaj | MT',
    dept:'MT',
    category: 'core',
    company: "Bajaj",
    cover: 'assets/images/rohit_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 38,
    name_:'Vipin',
    title: 'Goldman Sachs | ME',
    dept:'ME',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/vipin_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 37,
    name_:'Debaditya Das',
    title: 'Sprinklr | CS',
    dept:'CS',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/debaditya_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 36,
    name_:'Abhirup Pal',
    title: 'Sprinklr | IM',
    dept:'IM',
    category: 'software',
    company: "Sprinklr",
    cover: 'assets/images/abhirup_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 35,
    name_:'Abhijeet Singh',
    title: 'Graviton Research Capital LLP | CS',
    dept:'CS',
    category: 'software',
    company: "Graviton Research Capital LLP",
    cover: 'assets/images/abhijeet_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 34,
    name_:'Birru Lavanya',
    title: 'Goldman Sachs | HS',
    dept:'HS',
    category: 'quant',
    company: "Goldman Sachs",
    cover: 'assets/images/birru_cv.jpg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 33,
    name_:'Swapnil Yasasvi',
    title: 'Graviton Research Capital LLP | CS',
    dept:'CS',
    category: 'software',
    company: "Graviton Research Capital LLP",
    cover: 'assets/images/swapnil_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 32,
    name_:'Sayantan Sarkar',
    title: 'JLR | ME',
    dept:'ME',
    category: 'core',
    company: "JLR",
    cover: 'assets/images/sayantan_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 31,
    name_:'Nabhya Khoria',
    title: 'AlphaGrep | MA',
    dept:'MA',
    category: 'quant',
    company: "AlphaGrep",
    cover: 'assets/images/nabhya_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 30,
    name_:'Kalidindi Rohan',
    title: 'PnG | IM',
    dept:'IM',
    category: 'product',
    company: "PnG",
    cover: 'assets/images/kalidindi_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 29,
    name_:'Aorkodeep Mandal',
    title: 'BCG | EE',
    dept:'EE',
    category: 'consultancy',
    company: "BCG",
    cover: 'assets/images/aorkodeep_cv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 28,
    name_:'Aditi Maurya',
    title: 'DSP | CY',
    dept:'CY',
    category: 'quant',
    company: "DSP",
    cover: 'assets/images/aditicv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 27,
    name_:'Aditya Tiwari',
    title: 'Zepto | MA',
    dept:'MA',
    category: 'software',
    company: "Zepto",
    cover: 'assets/images/adityacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 26,
    name_:'Akansha Agarwal',
    title: 'JPMC | MF',
    dept:'MF',
    category: 'quant',
    company: "JPMC",
    cover: 'assets/images/akanshacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 25,
    name_:'Anil Kumar Yogi',
    title: 'Zepto | MA',
    dept:'MA',
    category: 'software',
    company: "Zepto",
    cover: 'assets/images/anilcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 24,
    name_:'Atulya Sharma',
    title: 'Salesforce | CSE',
    dept:'CSE',
    category: 'software',
    company: "Salesforce",
    cover: 'assets/images/atulyacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 23,
    name_:'Bhargav Khare',
    title: 'Info Edge Ltd. | NA',
    dept:'NA',
    category: 'data',
    company: "Info Edge Ltd.",
    cover: 'assets/images/bhargavcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 22,
    name_:'Diya Sarkar',
    title: 'LEK | CH',
    dept:'CH',
    category: 'consultancy',
    company: "LEK",
    cover: 'assets/images/diyacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 21,
    name_:'Mayank Agarwal',
    title: 'Morgan Stanley | MA',
    dept:'MA',
    category: 'quant',
    company: "Morgan Stanley",
    cover: 'assets/images/mayankcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 20,
    name_:'Preeti Nilanjana',
    title: 'Bajaj | EE',
    dept:'EE',
    category: 'core',
    company: "Bajaj",
    cover: 'assets/images/preeticv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 19,
    name_:'Sourya Roy',
    title: 'UiPath | ECE',
    dept:'ECE',
    category: 'software',
    company: "UiPath",
    cover: 'assets/images/souryacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 18,
    name_:'Polu Sreenidhi',
    title: 'JLR | EE',
    dept:'EE',
    category: 'core',
    company: "JLR",
    cover: 'assets/images/polucv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 17,
    name_:'Suneetha Abothula',
    title: 'JPMC | CSE',
    dept:'CSE',
    category: 'software',
    company: "JPMC",
    cover: 'assets/images/abothulacv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 16,
    name_:'Tuhin Subhra De',
    title: 'Udaan | CE',
    dept:'CE',
    category: 'data',
    company: "Udaan",
    cover: 'assets/images/tuhincv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 15,
    name_:'Gaurav Malakar',
    title: 'Sprinklr | CS',
    dept:'CS',
    category: 'software',
    company: "Sprinklr",
    cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*gTNcDFGV9TpQCxyK-hHukQ.jpeg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 14,
    name_:'Jothi Prakash',
    title: 'DE Shaw | ECE',
    dept:'ECE',
    category: 'software',
    company: "DE Shaw",
    cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*juOBrjqu3HPXZp-5vx7dUg.jpeg',
    profilecolor: '#FFC0CB',
  },
  {
    id: 13,
    name_:'Rajdeep Ghosh',
    title: 'Tiger Analytics | BT',
    dept:'BT',
    category: 'data',
    company: "Tiger Analytics",
    cover: 'assets/images/rajdeepcv.png',
    profilecolor: '#FFC0CB',
  },
  {
    id: 12,
    name_:'Sneha Majumder',
    title: 'EXL Services | CH',
    dept:'CH',
    category: 'data',
    company: "EXL Services",
    cover: 'assets/images/snehacv.png',
    profilecolor: '#FFC0CB',
  },
  
    {
      id: 11,
      name_:'Himadri Pandya',
      title: 'GS|ME',
      dept:'ME',
      category: 'software',
      company: "Goldman Sachs",
      cover: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*fdzetBj1ahE1RsdAAypJwg.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 10,
      name_:'Rithick Prabakar',
      title: 'Honeywell |ME',
      dept:'ME',
      category: 'software',
      company: "Honeywell",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*-EryacxM0sZ-8HgU3Za-sQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 9,
      name_:'Ishan Manchaanda',
      title: 'APT | IM',
      dept:'IM',
      category: 'quant',
      company: "APT",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*7JIVCogdWnGyP-P0oGXgfQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 8,
      name_:'Rashi Patil',
      title: 'Google | ECE',
      dept:'ECE',
      category: 'software',
      company: "Google",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MPPhQ8ausn0aqJ861Z49TA.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 7,
      name_:'Priyansha',
      title: 'Morgan Stanley | HS',
      dept:'HS',
      category: 'finance',
      company: "Morgan Stanley",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*owWIzFdeBIdBFvZgu5VNPA.jpeg',
      profilecolor: 'orange',
    },
    {
      id: 6,
      name_:'Bharat Uday',
      title: ' Bain & Co. | EE',
      dept:'EE',
      category: 'consultancy',
      company: "Bain & Co.",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*dHrn75J0kHwkVsq34W4Q-w.jpeg',
      profilecolor: 'Red',
    },
    {
      id: 5,
      name_:'Shubham Kulkarni',
      title: 'AWL|ECE',
      dept :'ECE',
      category: 'data',
      company: "AWL",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*V8RVXrzAYEcS9GyDzjHdYA.jpeg',
      profilecolor: 'green',
    },
    {
      id: 4,
      name_:'Utkarshini Dubey',
      title: 'Honeywell | IM',
      dept :'IM',
      category: 'software',
      company: "Honeywell",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*1hm-gev_rvr_HZ7rDvqBxA.png',
      profilecolor: '#FFC0CB',
    },
    {
      id: 3,
      name_:'Gidugu Srikar',
      title: 'Nvidia | ECE',
      dept:'ECE',
      category: 'core',
      company: "Nvidia",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*3cKBnK7ymiaprVpNBfB2Sw.png',
      profilecolor: '#FFC0CB',
    },
    
    {
      id: 2,
      name_:'Vaishnavi Singh',
      title: 'JPMC | MT',
      dept:'MT',
      category: 'finance',
      company: "JPMC",
      cover: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/1*LK33wAoyFvFwDjMw0hqxzQ.jpeg',
      profilecolor: '#FFC0CB',
    },
    {
      id: 1,
      name_:'Daksh Varshney',
      title: 'JLR | ECE',
      dept:'ECE',
      category: 'software',
      company: "JLR",
      cover: 'https://miro.medium.com/v2/resize:fit:1100/format:webp/1*MNIKdIiE-3x6a3-pIY96Ow.jpeg',
      profilecolor: '#FFC0CB',
    },
  ];
      
  